import React from "react";
import TextField from "@material-ui/core/TextField";
import { setLocalStorage } from "../utils";
import { ORDER_COMMENTS } from "../constants";

const FormCommentField: React.FC<{
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}> = ({ value, setValue }) => {
  React.useEffect(() => {
    setLocalStorage(ORDER_COMMENTS, value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  return (
    <TextField
      variant="outlined"
      label="Comments"
      fullWidth
      margin="normal"
      value={value}
      onChange={handleChange}
      helperText="Optional - provide additional order details"
    />
  );
};

export default FormCommentField;
